module.exports = __webpack_public_path__ + "static/image-pascoe-e48b95f2ae36602fdcf8e5978974d41d.jpg";